module.exports = __webpack_public_path__ + "static/media/step-4a-feet.4c38214a.gif";